<template>
  <div></div>
</template>

<script lang="ts" setup>
import { useScript, useHead } from '@unhead/vue'
import { promiseTimeout } from '@vueuse/core'

import { isClient } from '/@shared/app'
import { useAppStore } from '/@/stores'

const appStore = useAppStore()

const GOOGLE_TAG_MANAGER_ID = 'GTM-5JMF6P4'
const GOOGLE_TAG_MANAGER_URL = 'https://www.googletagmanager.com/gtm.js'

useHead({
  noscript: [
    {
      key: 'gtag-noscript',
      tagPosition: 'bodyOpen',
      innerHTML: `<iframe src="https://www.googletagmanager.com/ns.html?id=${GOOGLE_TAG_MANAGER_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
    },
  ],

  link: [
    {
      key: 'gtag-preconnect',
      rel: 'preconnect',
      href: 'https://www.googletagmanager.com',
    },
    {
      key: 'ga-preconnect',
      rel: 'preconnect',
      href: 'https://www.google-analytics.com',
    },
    {
      key: 'termly-preconnect',
      rel: 'preconnect',
      href: 'https://app.termly.io',
    },
  ],
})

useScript(
  {
    key: 'gtag',
    src: `${GOOGLE_TAG_MANAGER_URL}?id=` + GOOGLE_TAG_MANAGER_ID,
    defer: true,
    tagPosition: 'head',
    referrerpolicy: false,
    crossorigin: false,
  },
  {
    beforeInit() {
      if (!isClient) return

      if (appStore.features?.country_code === 'UA') {
        window.dataLayer = [{ skipMetrika: true }]
      }

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'gtm.start': Date.now(),
        event: 'gtm.js',
      })
    },
    use() {
      return { dataLayer: window.dataLayer }
    },
  }
)

async function showTermlyAfterOnTimeout() {
  await promiseTimeout(15_000)
  const el = document.getElementById('termly-code-snippet-support')

  if (!el) return

  el.classList.add('is-visible')
}

if (isClient) showTermlyAfterOnTimeout()
</script>
